__turbopack_context__.v({
  "container": "_3Qugya_container",
});
